// ─────────────────────────────────────────────────────────────────
// Glass-i — Payment / Receipt Voucher constants (Stage 6B.6).
// ─────────────────────────────────────────────────────────────────

export const PAYMENT_TYPES = [
  { value: 'payment', label: 'Payment (money out)' },
  { value: 'receipt', label: 'Receipt (money in)'  }
];

export const PAYMENT_TYPE_LABEL = {
  payment: 'Payment',
  receipt: 'Receipt'
};

export const PAYMENT_TYPE_COLOR = {
  payment: 'volcano',
  receipt: 'green'
};

export const PAYMENT_MODES = [
  { value: 'cash',       label: 'Cash'      },
  { value: 'bank',       label: 'Bank'      },
  { value: 'upi',        label: 'UPI'       },
  { value: 'cheque',     label: 'Cheque'    },
  { value: 'rtgs',       label: 'RTGS'      },
  { value: 'neft',       label: 'NEFT'      },
  { value: 'imps',       label: 'IMPS'      },
  { value: 'adjustment', label: 'Adjustment'}
];

// Stage 6B.7C — cheque tracking lifecycle. Mirrors the DB CHECK on
// payments.cheque_status added by migration 0022.
export const CHEQUE_STATUSES = [
  { value: 'pending',   label: 'Pending',   color: 'gold'    },
  { value: 'deposited', label: 'Deposited', color: 'blue'    },
  { value: 'cleared',   label: 'Cleared',   color: 'green'   },
  { value: 'bounced',   label: 'Bounced',   color: 'red'     },
  { value: 'cancelled', label: 'Cancelled', color: 'default' }
];
export const CHEQUE_STATUS_LABEL = Object.fromEntries(
  CHEQUE_STATUSES.map((s) => [s.value, s.label])
);
export const CHEQUE_STATUS_COLOR = Object.fromEntries(
  CHEQUE_STATUSES.map((s) => [s.value, s.color])
);

export const PAYMENT_MODE_LABEL = Object.fromEntries(
  PAYMENT_MODES.map((m) => [m.value, m.label])
);

export const PAYMENT_STATUSES = [
  { value: 'draft',     label: 'Draft',     color: 'default' },
  { value: 'posted',    label: 'Posted',    color: 'green'   },
  { value: 'cancelled', label: 'Cancelled', color: 'red'     }
];

export const PAYMENT_STATUS_COLOR = Object.fromEntries(
  PAYMENT_STATUSES.map((s) => [s.value, s.color])
);

export const PAYMENT_STATUS_LABEL = Object.fromEntries(
  PAYMENT_STATUSES.map((s) => [s.value, s.label])
);

export const PARTY_TYPES = [
  { value: 'supplier', label: 'Supplier' },
  { value: 'customer', label: 'Customer' },
  { value: 'other',    label: 'Other'    }
];

export const PARTY_TYPE_LABEL = Object.fromEntries(
  PARTY_TYPES.map((p) => [p.value, p.label])
);

export function formatINR(n) {
  const v = Number(n) || 0;
  return v.toLocaleString('en-IN', {
    minimumFractionDigits: 2, maximumFractionDigits: 2
  });
}
